import Box from "@mui/material/Box";
import Grid, { GridProps } from "@mui/material/Grid";
import React from "react";
import "./PageContainer.scss";

interface PageContainerProps extends GridProps {
  size?: number | string;
  flush?: boolean;
  editorPage?: boolean;
}

export default function PageContainer(props: PageContainerProps) {
  const { size, children, flush, editorPage, sx, ...rest } = props;
  const mergedSx = [{ minHeight: 0 }, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])];

  if (editorPage) {
    return (
      <Box
        className="template-editor-page-outer"
        sx={{
          width: "100%",
          flex: 1,
          minHeight: 0,
          height: "100%",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          className={[
            "page-container",
            "page-container--flush",
            "template-editor-page",
          ].join(" ")}
          sx={{ width: "100%", maxWidth: "100%" }}
        >
          {children}
        </Box>
      </Box>
    );
  }

  const containerClass = [
    "page-container",
    flush && "page-container--flush",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <Grid
      container
      justifyContent={flush ? "stretch" : "center"}
      sx={{ width: "100%", height: "100%", minHeight: 0 }}
    >
      <Grid
        container
        className={containerClass}
        maxWidth={flush ? "100%" : `${size ?? 1330}px`}
        {...rest}
        sx={mergedSx}
      >
        {children}
      </Grid>
    </Grid>
  );
}
